import React from 'react';
import { Drawer, Empty, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

/** 单个点位信息（来自图中 category 为 Comment 且带 pointName/pointNo/pointDesc 的文本框） */
export interface PointInfo {
  key: string;
  pointName: string;
  pointNo: string;
  pointDesc: string;
}

interface PointInfoDrawerProps {
  open: boolean;
  points: PointInfo[];
  onClose: () => void;
}

const columns: ColumnsType<PointInfo> = [
  {
    title: '序号',
    key: 'index',
    width: 60,
    render: (_value, _record, index) => index + 1,
  },
  { title: '点位名称', dataIndex: 'pointName', key: 'pointName' },
  { title: '点位号', dataIndex: 'pointNo', key: 'pointNo', width: 120 },
  { title: '点位描述', dataIndex: 'pointDesc', key: 'pointDesc' },
];

/** 点位信息抽屉：集中列出当前流程图中的所有点位 */
const PointInfoDrawer = ({ open, points, onClose }: PointInfoDrawerProps) => {
  return (
    <Drawer title="点位信息" placement="right" width={560} open={open} onClose={onClose}>
      {points.length > 0 ? (
        <Table
          rowKey="key"
          size="small"
          pagination={false}
          dataSource={points}
          columns={columns}
        />
      ) : (
        <Empty description="暂无点位信息" />
      )}
    </Drawer>
  );
};

export default PointInfoDrawer;
